import { render, staticRenderFns } from "./TaskPreview.vue?vue&type=template&id=d8bf1f9c"
import script from "./TaskPreview.vue?vue&type=script&lang=js"
export * from "./TaskPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports